export const CONTENTID = 'content';
export const CWA_DOWNLOAD_LINK = 'https://www.citrix.com/downloads/workspace-app/';
export const GOOGLE_CHROME_DOWNLOAD_LINK = 'https://www.google.com/chrome/';
